// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3405":"6c995f36","4087":"32c4ff42","5625":"32c4ff42","6432":"32c4ff42","8191":"a683554c","9540":"3f79c1fc"}[chunkId] + ".chunk.css";
};